// nprmaal 100
// scroll 60

var navBarBlock = {
    $navBarBlock: $('.nav-bar-block'),
    $window: $(window),

    init: function() {
        var _this = this;

        if (!_this.$navBarBlock.length) {
            return;
        }

        _this.$hamburger = _this.$navBarBlock.find('.hamburger');
        _this.$menu = _this.$navBarBlock.find('.menu');

        _this.listener();
        _this.checkScroll();
    },

    listener: function() {
        var _this = this;

        _this.$window.scroll(function() {
            _this.checkScroll();
        });

        _this.$hamburger.click(_this.toggleMenu.bind(_this));
    },

    menuActive: false,
    toggleMenu: function() {
        var _this = this;

        _this.setMenu(!_this.menuActive);

        if (_this.$hamburger.hasClass('is-active')) {
            _this.$hamburger
                .find('.icon')
                .removeClass('menu-item')
                .addClass('menu-kruisje');
        } else {
            _this.$hamburger
                .find('.icon')
                .removeClass('menu-kruisje')
                .addClass('menu-item');
        }
    },

    setMenu: function(isActive) {
        var _this = this;

        _this.menuActive = isActive;
        _this.$hamburger.toggleClass('is-active', isActive);
        _this.$menu.toggleClass('is-active', isActive);
    },

    checkScroll: function() {
        var _this = this;

        var isScrolled = _this.$window.scrollTop() > 5;

        if (isScrolled === _this.isScrolledCache) {
            return;
        }

        _this.isScrolledCache = isScrolled;

        _this.$navBarBlock.toggleClass('is-scrolled', isScrolled);
    }
};
